import { createAction, props } from '@ngrx/store';
import { VersionApiError } from './version.errors';
import { Version } from './version.model';

export enum VersionActionTypes {
  VersionsPageLoaded = '[Versions Page] Page Loaded',
  VersionsLoaded = '[Version Effect] Versions Loaded',
  VersionsErrored = '[Version Effect] Versions Errored',
}

export const VersionPageLoadedAction = createAction(VersionActionTypes.VersionsPageLoaded);

export const VersionLoadedAction = createAction(
  VersionActionTypes.VersionsLoaded,
  props<{ versions: Version[] }>(),
);

export const VersionErroredAction = createAction(
  VersionActionTypes.VersionsErrored,
  props<{ error: VersionApiError }>(),
);
